<template>
  <EditContent property="termsOfService" />
</template>
<script setup lang="ts">
import EditContent from "./EditContent.vue";
</script>
